import React, { useEffect, useState } from "react";
import "./index.css";

function ClimaFlutuante() {
  const [clima, setClima] = useState(null);
  const [loading, setLoading] = useState(true);
  const [aberto, setAberto] = useState(false); // Estado para controlar se está aberto/fechado

  const obterInfoClima = (code) => {
    if (code === 0) return { icone: "☀️", texto: "Ensolarado" };
    if (code >= 1 && code <= 3) return { icone: "⛅", texto: "Parcialmente Nublado" };
    if (code >= 45 && code <= 48) return { icone: "🌫️", texto: "Nevoeiro" };
    if (code >= 51 && code <= 67) return { icone: "🌧️", texto: "Chuva" };
    if (code >= 80 && code <= 82) return { icone: "🌦️", texto: "Pancadas de Chuva" };
    if (code >= 95) return { icone: "⛈️", texto: "Tempestade" };
    return { icone: "🌡️", texto: "Tempo Estável" };
  };

  const carregarClimaPorIP = async () => {
    try {
      const ipRes = await fetch("https://ipapi.co/json/");
      const ipData = await ipRes.json();

      const lat = ipData?.latitude || -22.9068;
      const lon = ipData?.longitude || -43.1729;
      const cidade = ipData?.city || "";

      const res = await fetch(
        `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true&daily=temperature_2m_max,temperature_2m_min,precipitation_probability_max&timezone=auto`
      );
      const data = await res.json();

      if (data?.current_weather && data?.daily) {
        const info = obterInfoClima(data.current_weather.weathercode);
        setClima({
          cidade,
          tempAtual: Math.round(data.current_weather.temperature),
          tempMax: Math.round(data.daily.temperature_2m_max[0]),
          tempMin: Math.round(data.daily.temperature_2m_min[0]),
          chanceChuva: data.daily.precipitation_probability_max[0] || 0,
          ...info,
        });
      }
    } catch (err) {
      console.error("Erro ao carregar clima:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarClimaPorIP();
  }, []);

  if (loading || !clima) return null;

  return (
    <div className={`clima-flutuante-wrapper ${aberto ? "expandido" : "recolhido"}`}>
      <div className="clima-flutuante-header" onClick={() => setAberto(!aberto)}>
        <span className="clima-icone">{clima.icone}</span>
        <span className="clima-temp-resumo">{clima.tempAtual}°C</span>
        <span className="clima-toggle-arrow">{aberto ? "▲" : "▼"}</span>
      </div>

      {aberto && (
        <div className="clima-flutuante-conteudo">
          <div className="clima-texto-detalhe">{clima.texto}</div>
          {clima.cidade && <div className="clima-cidade-detalhe">📍 {clima.cidade}</div>}
          <div className="clima-detalhes-dia">
            <span className="clima-maxmin">
              ↑{clima.tempMax}° ↓{clima.tempMin}°
            </span>
            {clima.chanceChuva > 0 && (
              <span className="clima-chuva">☔ {clima.chanceChuva}%</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ClimaFlutuante;